import { CalendarClock } from "lucide-react";
import { Reveal, Rise } from "./Reveal";
import GlowButton from "./GlowButton";
import content from "../content";
import { SectionBg } from "./SectionBg";

export default function PrayerSection() {
  const { prayer } = content;
  const [imgA, imgB, imgC] = prayer.images;

  return (
    <section id="oracion" className="relative w-full bg-navy py-28 md:py-36 overflow-hidden" data-testid="prayer-section">
      <SectionBg image="/images/prayer-2.webp" tint="navy" />
      <div
        className="pointer-events-none absolute inset-0 opacity-40"
        style={{ background: "radial-gradient(circle at 30% 40%, rgba(33,112,232,0.18), transparent 60%)" }}
        aria-hidden="true"
      />

      <div className="relative w-full max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Text + CTA */}
        <Reveal className="max-w-xl">
          <Rise>
            <p className="eyebrow mb-6">{prayer.eyebrow}</p>
          </Rise>
          <Rise>
            <h2 className="display text-white text-[clamp(2.5rem,7vw,5.5rem)] mb-6">
              {prayer.title}
            </h2>
          </Rise>
          <Rise>
            <p className="font-poppins text-ceramic/80 text-base md:text-lg leading-relaxed mb-6">
              {prayer.text}
            </p>
          </Rise>
          {prayer.callout && (
            <Rise>
              <div
                className="flex items-start gap-3 rounded-2xl border border-gold/40 bg-gold/10 px-5 py-4 mb-9"
                data-testid="prayer-callout"
              >
                <CalendarClock size={20} className="text-gold mt-0.5 shrink-0" />
                <p className="font-poppins text-white text-sm md:text-base leading-relaxed">
                  {prayer.callout}
                </p>
              </div>
            </Rise>
          )}
          <Rise>
            <GlowButton href={prayer.cta.href} variant="blue" testId="prayer-cta">
              {prayer.cta.label}
            </GlowButton>
          </Rise>
        </Reveal>

        {/* Image collage */}
        <Reveal className="relative" amount={0.2}>
          <Rise className="relative">
            <div className="absolute -inset-4 rounded-[2.5rem] bg-electric/15 blur-3xl" aria-hidden="true" />
            <div className="relative grid grid-cols-2 grid-rows-2 gap-3 md:gap-4 h-[440px] md:h-[540px]">
              <figure className="row-span-2 relative overflow-hidden rounded-3xl border border-white/10 group">
                <img
                  src={imgB.src}
                  alt={imgB.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </figure>
              <figure className="relative overflow-hidden rounded-3xl border border-white/10 group">
                <img
                  src={imgA.src}
                  alt={imgA.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </figure>
              <figure className="relative overflow-hidden rounded-3xl border border-white/10 group">
                <img
                  src={imgC.src}
                  alt={imgC.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </figure>
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-navy/40 via-transparent to-transparent rounded-[2rem]" />
            </div>
          </Rise>
        </Reveal>
      </div>
    </section>
  );
}
